import { useGetProposalLocation } from '@/api/queries/proposal/useGetProposalLocation';
import { legacyProposalPath } from '@/ui/pages/legacyProposalPage/legacyProposalPath';
import RedirectingPlaceholder from '@/ui/pages/legacyQuoteRedirectPage/RedirectingPlaceholder';
import { FC } from 'react';
import { Redirect } from 'react-router-dom';

type Props = {
  proposalId: string;
};

/**
 * Forwards `/quotes/:quoteId` on to wherever the Proposal now lives. The route
 * predates the builder and is still held in bookmarks and older links.
 */
const EditQuoteRedirectPage: FC<Props> = (props) => {
  const { proposalId } = props;

  const { proposal, isError } = useGetProposalLocation(proposalId);

  // An id that resolves to no Proposal — a deleted one, a legacy Invoice, or
  // another Account's — has no destination to offer.
  if (isError) {
    return <Redirect to="/deals" />;
  }

  if (!proposal) {
    return <RedirectingPlaceholder label="Opening the proposal" />;
  }

  const { project } = proposal;

  // A legacy Project's Proposals are no longer rendered anywhere.
  if (project.version < 2) {
    return <Redirect to={legacyProposalPath(proposalId, project.publicId)} />;
  }

  return (
    <Redirect
      to={`/projects/${project.publicId}/proposals/${proposal.publicId}`}
    />
  );
};

export default EditQuoteRedirectPage;
